<template>
  <div
    :class="[
      'container-' + organism.containerWidth,
      'organism form-cta bg-gray-500',
    ]"
  >
    <div
      class="content max-w-[1220px] mx-auto flex flex-wrap xl:flex-nowrap gap-10 justify-center items-start pt-20 pb-10 px-8"
    >
      <NuxtLink
        v-if="organism.imageLink"
        :to="organism.imageLink"
        target="_blank"
        class="image-link"
      >
        <img
          v-bind="useResponsiveImage(organism.image)"
          class="rounded-full object-cover object-[60%_50%] w-[240px] aspect-square bg-gradient-to-b to-[#CCB59F] from-[#E1DBD4] border border-gray-400"
        />
      </NuxtLink>
      <div v-else class="image-container">
        <img
          v-bind="useResponsiveImage(organism.image)"
          class="rounded-full object-cover object-[60%_50%] w-[240px] aspect-square bg-gradient-to-b to-[#CCB59F] from-[#E1DBD4] border border-gray-400"
        />
      </div>

      <div class="text max-w-[min(400px,_100%)]">
        <h2
          class="mb-7 font-figtree font-semibold text-3xl md:text-[40px] leading-none text-gray-800"
        >
          {{ organism.title1 }}
        </h2>
        <div
          class="text-lg text-gray-500 description font-figtree"
          v-html="organism.description"
        ></div>
      </div>
      <div class="form w-full max-w-[522px]">
        <header
          v-if="organism.formHeader"
          v-html="organism.formHeader"
          class="mb-4"
        ></header>
        <FormsDynamicGravityForm :gfid="gfid" />
      </div>
    </div>
  </div>
</template>

<style>
.form-cta {
  .text {
    h2 {
      @apply mb-2 max-w-full text-white;
    }

    h3 {
      @apply font-figtree text-2xl text-white font-semibold;
    }

    h4 {
      @apply text-white;
    }

    p {
      @apply mb-4 leading-tight text-white;
    }

    a {
      @apply text-white;
    }

    ul {
      @apply pl-8 pb-5 text-white;
    }

    .icon {
      @apply relative;

      &::before {
        @apply absolute w-5 h-5 -left-8 top-[1px];
      }

      &.icon-phone::before {
        content: url("/img/heroicon-phone.svg");
      }

      &.icon-home::before {
        content: url("/img/heroicon-home.svg");
      }

      &.icon-link::before {
        content: url("/img/heroicon-link.svg");
      }
    }
  }

  form {
    @apply px-0 !important;
    input[type="text"] {
      @apply border border-gray-400 col-span-2 md:col-span-1;

      &::placeholder {
        @apply text-sm;
      }
    }
    select {
      @apply border border-gray-400 col-span-2 text-sm text-gray-500;
    }
    textarea {
      @apply border border-gray-400;

      &::placeholder {
        @apply text-sm;
      }
    }

    h1,
    h2,
    h3,
    h4,
    ul,
    li,
    p,
    span {
      @apply text-white;
    }

    a {
      @apply text-white;
    }
  }

  #confirmation-message {
    @apply text-white;
  }
}
</style>

<script setup>
const props = defineProps({
  organism: Object,
  gfid: Number,
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
